import { PropsWithChildren } from "react";
import { Text, TextProps } from "@chakra-ui/react";

const StatText = ({ children, ...props }: PropsWithChildren<TextProps>) => (
  <Text textStyle="body2" noOfLines={1} w="100%" {...props}>
    {children}
  </Text>
);

export default StatText;
